import LockResetIcon from "@mui/icons-material/LockReset";
import {
  Alert,
  Avatar,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Paper,
} from "@mui/material";
import React, { useState } from "react";
import ApiFetch from "../../components/ApiFetch";
import ButtonControl from "../../components/controls/ButtonControl";
import InputControl from "../../components/controls/InputControl";
import { API_USERS_ACCOUNT } from "../../context/ApiEndPoints";
import useAppContext from "../../hooks/useAppContext";
import useComponentContext from "../../hooks/useComponentContext";
import useForm from "../../hooks/useForm";

const objRecord = {
  oldPassword: "",
  password: "",
  confirmPassword: "",
};

export default function UserAccount() {
  const { user, setUser } = useAppContext();
  const { setNotify } = useComponentContext();
  const [isSaving, setIsSaving] = useState(false);

  const validate = (input = values) => {
    let temp = { ...errors };

    if ("oldPassword" in input) {
      temp.oldPassword =
        /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$ %^&*-]).{8,}$/.test(
          input.oldPassword
        )
          ? ""
          : "Minimum 8 characters, at least one upper case letter, one lower case letter, one number and one special character";

      temp.oldPassword = input.oldPassword
        ? temp.oldPassword
        : "Old Password is required.";
    }
    if ("password" in input) {
      temp.password =
        /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$ %^&*-]).{8,}$/.test(
          input.password
        )
          ? ""
          : "Minimum 8 characters, at least one upper case letter, one lower case letter, one number and one special character";

      temp.password = input.password
        ? temp.password
        : "New Password is required.";
    }
    if ("confirmPassword" in input) {
      temp.confirmPassword =
        input.confirmPassword === values.password
          ? ""
          : "Password did not match";

      temp.confirmPassword = input.confirmPassword
        ? temp.confirmPassword
        : "Confirm Password is required.";
    }

    setErrors({ ...temp });
    if (input === values) return Object.values(temp).every((x) => x === "");
  };

  const { values, handleInputChange, errors, setErrors } = useForm(
    objRecord,
    true,
    validate
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validate()) {
      setIsSaving(true);
      // PUT Request using fetch
      const requestOptions = {
        method: "PUT",
        headers: {
          Authorization: "Bearer " + user.token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      };
      const results = await ApiFetch(
        API_USERS_ACCOUNT,
        requestOptions,
        setNotify
      );

      setIsSaving(false);
      if (results) {
        localStorage.removeItem("X-Access-Token");
        setUser(false);
      }
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid container>
        <Grid item component={Paper} xs={12} md={6}>
          <List>
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <LockResetIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary="Account" secondary="Change Password" />
            </ListItem>
          </List>
          <Alert severity="info">
            You will be redirected to login screen upon successfully changing
            password to login with new password.
          </Alert>
          <Paper elevation={0} sx={{ p: 3 }}>
            <InputControl
              type="password"
              label="Old Password"
              name="oldPassword"
              value={values.oldPassword}
              onChange={handleInputChange}
              error={errors.oldPassword}
            />
            <InputControl
              type="password"
              label="New Password"
              name="password"
              value={values.password}
              onChange={handleInputChange}
              error={errors.password}
            />
            <InputControl
              type="password"
              label="Confirm Password"
              name="confirmPassword"
              value={values.confirmPassword}
              onChange={handleInputChange}
              error={errors.confirmPassword}
            />
            {!isSaving && <ButtonControl type="submit" text="Save" />}
            {isSaving && (
              <ButtonControl
                type="submit"
                text="Saving..."
                isSaving={isSaving}
                disabled
              />
            )}
          </Paper>
        </Grid>
      </Grid>
    </form>
  );
}
